<template>
  <div class="doclib-preview">
    <div class="preview-header">
      <i class="iconfont icon-back" @click="closeTag"></i>
      <p>{{previewData.fileName}}</p>
      <span></span>
    </div>
    <template v-if="previewData.extensionCategory === 'image'">
      <template v-if="!imageLoadFailed && imagePreviewUrl">
        <div class="image-container">
          <img :src="imagePreviewUrl" alt="" @error="handleImageError">
        </div>
      </template>
      <template v-else>
        <iframe
          class="office-iframe"
          id="office-iframe"
          :src="previewData.preview_url"
          frameBorder="0"
          :allowFullScreen="true"
        />
      </template>
    </template>
    <template v-else-if="['video', 'audio'].includes(previewData.extensionCategory)">
      <div class="video-context">
        <video-player :videoData="previewData"></video-player>
      </div>
    </template>
    <template v-else>
      <iframe
        class="office-iframe"
        id="office-iframe"
        :src="previewData.preview_url"
        frameBorder="0"
        :allowFullScreen="true"
      />
    </template>

    <div class="preview-button">
      <div>
        <i class="iconfont icon-icon-gongnenglei" @click="handleDownload"></i>
        <span>下载</span>
      </div>
      <div>
        <i class="iconfont icon-a-icon-gongnenglei1" @click="handleShare"></i>
        <span>分享</span>
      </div>
    </div>
  </div>
</template>
<script>
import ajax from '@/utils/ajax'
import { BOOK_PREVIEW, PREVIEW_GETSWITCH, PREVIEW_PREVIEWINFO, BOOK_PRESIGN_DOWNLOAD, LIBRARY_USER_PERMISSIONS } from '@/config/api'
import VideoPlayer from './VideoPlayer'
import config from '@/config'
import { menuMixin, CommonMixin } from '../file/commonMixin'
import { toast } from '@/utils/common'
export default {
  name: 'DoclibPreview',
  data () {
    return {
      previewData: {},
      cardData: {},
      imageLoadFailed: false
    }
  },
  mixins: [menuMixin, CommonMixin],
  components: {
    VideoPlayer
  },
  created () {
    this.initPreviewData()
    this.initPermission()
  },
  mounted () {

  },
  computed: {
    imagePreviewUrl () {
      return this.previewData.download_url || this.previewData.preview_url
    }
  },
  methods: {
    closeTag () {
      this.appFn({
        action: 'route',
        data: `${window.location.origin}/h5/doclib/files/${this.$route.query.library_id}`
      }, () => {
        this.$router.go(-1)
      })
    },
    initPermission () {
      ajax({
        url: LIBRARY_USER_PERMISSIONS,
        baseUrl: config.doclib_application_url,
        noPrefix: true,
        data: {
          book_id: this.$route.query.book_id,
          library_id: this.$route.query.library_id
        }
      }).then((res) => {
        this.permissionsData = res.data
      })
    },
    initPreviewData () {
      ajax({
        url: `${PREVIEW_GETSWITCH}`,
        noPrefix: true
      }).then((res) => {
        if (res.success) {
          if (res.data.preview_enable) {
            ajax({
              url: `${PREVIEW_PREVIEWINFO}`,
              noPrefix: true,
              data: {
                file_version_number: this.$route.query.file_version || '',
                kbase: {
                  book_id: this.$route.query.book_id,
                  library_id: this.$route.query.library_id,
                  file_version_number: this.$route.query.file_version || ''
                },
                kind: 'wps',
                scene: 'kbase',
                wps_enable: true
              },
              errorCallBack: () => {
                this.$router.go(-1)
              }
            }).then(previewRes => {
              if (previewRes.success) {
                this.setPreviewData(previewRes.data)
              }
            })
          } else {
            ajax({
              url: `${BOOK_PREVIEW}?book_id=${this.$route.query.book_id}&library_id=${this.$route.query.library_id}&file_version_number=${this.$route.query.file_version || ''}`,
              baseUrl: config.doclib_application_url,
              noPrefix: true,
              errorCallBack: () => {
                this.$router.go(-1)
              }
            }).then(previewRes => {
              if (previewRes.success) {
                this.setPreviewData(previewRes.data)
              }
            })
          }
        }
      })
    },
    setPreviewData (data) {
      this.imageLoadFailed = false
      this.previewData = data
      this.setCardData(data)
    },
    setCardData (data) {
      this.cardData = {
        name: data.fileName,
        version: data.action_result.file_version,
        library_id: this.$route.query.library_id,
        id: this.$route.query.book_id,
        extension: data.action_result.file_extension,
        extension_category: data.extensionCategory
      }
    },
    handleImageError () {
      this.imageLoadFailed = true
    },
    handleDownload () {
      let has_permission = false
      this.permissionsData.permissions && this.permissionsData.permissions.forEach(item => {
        if (item.id === 'download' && item.value) {
          has_permission = true
        }
      })
      if (this.permissionsData.is_admin || has_permission) {
        this.appFn({
          action: 'download',
          data: this.cardData
        }, () => {
          ajax({
            url: BOOK_PRESIGN_DOWNLOAD,
            baseUrl: config.doclib_application_url,
            noPrefix: true,
            data: {
              book_id: this.$route.query.book_id,
              library_id: this.$route.query.library_id
            }
          }).then(res => {
            if (res.success) {
              this.downloadFile(res.data, this.cardData.name)
            } else {
              toast(res.message)
            }
          })
        })
      } else {
        toast('暂无下载权限')
      }
    },
    handleShare () {
      let shareLink = `${window.location.href}`
      this.appFn({
        action: 'share',
        data: shareLink
      }, () => {
        this.copyLinkToClipboard(shareLink)
      })
      toast('链接复制成功')
    }
  }
}
</script>
<style lang="postcss" scoped>
.doclib-preview {
  width: 100%;
  height: 100%;
  position: relative;

  & .preview-header {
    width: 100%;
    display: flex;
    height: 44px;
    padding: 0px 20px;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    &>p {
      display: block;
      width: calc(100% - 80px);
      padding-left: 20px;
      padding-right: 20px;
      box-sizing: border-box;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      align-items: center;
      color: #1B2532;
      font-family: "PingFang SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 600;

      & img {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }
    }

    &>i {
      color: #1B2532;
      font-size: 16px;
      line-height: normal;
    }

    &>span {
      width: 20px;
    }
  }

  & .office-iframe {
    width: 100%;
    height: calc(100% - 120px);
  }

  & .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100% - 44px);
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
  }

  & .video-context {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100% - 44px);
    position: relative;
    z-index: 1;
  }

  & .preview-button {
    display: flex;
    padding: 8px 0;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    border-top: 1px solid #EBF0F5;
    background: #fff;

    & div {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      & i {
        font-size: 28px;
      }

      & span {
        color: #1B2532;
        font-family: "PingFang SC";
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px;
      }
    }
  }
}
</style>
